var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper-slide',[_c('div',{staticClass:"slide-wrapper"},[_c('div',{staticClass:"slide-container"},[_c('div',{staticClass:"tag"},[_vm._v("\n        "+_vm._s(_vm.tag)+" "),_c('a',{staticClass:"tag-close",on:{"click":_vm.clickTagItem}},[_vm._v("X")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0816ee6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompTagTabItem.vue
// module id = null
// module chunks = 